<template>
  <div class="index">
    <!-- banner -->
    <slider :sliderData="sliderData"></slider>
    <!-- 无图新闻 -->
    <div class="wutuDiv w1200 flexDiv">
      <xxggList
        :xxggList="xxggList"
        moreLink="/list.html?HType=2&CId=5498"
      ></xxggList>
      <jxglList
        :jxglList="jxglList"
        moreLink="/list.html?HType=2&CId=5503"
      ></jxglList>
    </div>
    <!-- 快速链接 -->
    <!-- <div class="ksljDiv w1200">
            <div class="titleBox flexDiv">
                <p>
                    <em>快速链接</em>
                    <span>QUICK LINKS</span>
                </p>
            </div>
            <div class="formBox">
                <form action="" class="flexDiv">
                    <el-select placeholder="——院内链接——" v-model="value1">
                        <router-link :to="item.Url"  v-for="item in ynlj" :key="item.ID">
                            <el-option :label="item.label" :value="item.Title"></el-option>
                        </router-link>
                    </el-select>
                    <el-select placeholder="——常用链接——" v-model="value2">
                        <router-link :to="item.Url"  v-for="item in cylj" :key="item.ID">
                            <el-option :label="item.label" :value="item.Title"></el-option>
                        </router-link>
                    </el-select>
                    <el-select placeholder="——校外产学研基地——" v-model="value3">
                        <router-link :to="item.Url"  v-for="item in xwjd" :key="item.ID">
                            <el-option :label="item.label" :value="item.Title"></el-option>
                        </router-link>
                    </el-select>
                </form>
            </div>
        </div> -->
  </div>
</template>
<script>
import "../assets/css/index.css";
import slider from "@/components/slider";
import xxggList from "@/components/xxggList";
import jxglList from "@/components/jxglList";
export default {
  name: "index",
  components: {
    slider,
    xxggList,
    jxglList
  },
  data() {
    return {
      baseUrl: "this.baseUrl",
      sliderData: [],
      xxggList: [],
      jxglList: [],
      ynlj: [],
      cylj: [],
      xwjd: [],
      value1: "",
      value2: "",
      value3: ""
    };
  },
  created() {
    this.$root.$children["0"].$children["0"].menuListOne.forEach(
      element => (element.On = false)
    );
    this.sliderData = this.Base.GetFilesInfoByCid(5510, 1, "", 6, 1); //banner
    this.xxggList = this.Base.GetNewsInfoByCid(5498, false, 1, "", 5); //信息公告
    this.jxglList = this.Base.GetNewsInfoByCid(5503, false, 1, "", 5); //教学管理制度
    this.ynlj = this.Base.GetNewsInfoByCid(5518, false, 1, "", 10);
    this.cylj = this.Base.GetNewsInfoByCid(5519, false, 1, "", 10);
    this.xwjd = this.Base.GetNewsInfoByCid(5520, false, 1, "", 10);
    // console.log(this.sliderData);
  }
};
</script>
<style lang="less" scoped>
.el-select {
  width: 300px;
}
.index {
  margin-bottom: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue